import React, { useState, useEffect } from "react";

import { LoadingSpinner } from "@newsela/angelou";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import ChallengeLandingHeader from "@/challenges/ChallengeLandingHeader";
import ChallengesFolder from "@/challenges/ChallengesFolder";
import useChallengesGet from "@/challenges/utils/useChallengesGet";
import ChallengesTeacher from "../ChallengesTeacher/ChallengesTeacher";
import ChallengeTeacherHomePage from "../ChallengeTeacherHomePage/ChallengeTeacherHomePage";
import { challengeWrapper, loadingWrapper } from "./ChallengeWrapperView.style";

const propTypes = {
  isHomeVersion: PropTypes.bool,
  isTeacher: PropTypes.bool,
  setNoData: PropTypes.any,
};

const ChallengeWrapperView = ({
  isHomeVersion,
  isTeacher = false,
  setNoData,
}) => {
  const [activeTab, setActiveTab] = useState(null);
  const [activeData, setActiveData] = useState(null);
  const [subjects, setSubject] = useState([]);
  const [expirationDate, setExpirationDate] = useState(null);
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [getChallenges] = useChallengesGet();

  const updateChallengesData = async () => {
    const now = new Date();
    const { data, error } = await getChallenges({
      month: now.getMonth() + 1,
      year: now.getFullYear(),
    });
    setData(data?.data);
    setError(data?.error_message || error);
  };

  useEffect(() => {
    updateChallengesData();
  }, []);
  useEffect(() => {
    setIsLoading(true);
    if (!error && data) {
      setActiveTab(data[0]?.subject);
      setIsLoading(false);
      setNoData(false);
      setSubject(data.map((challenge) => challenge.subject));
    } else if (error) {
      setNoData(true);
      if (!isHomeVersion) {
        router.push("/home");
      }
      setIsLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (activeTab && data) {
      setActiveData(
        data?.filter((challenge) => challenge.subject === activeTab)[0],
      );
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeData) {
      setExpirationDate(new Date(activeData?.expiration) || new Date());
    }
  }, [activeData]);
  return isLoading && !error ? (
    <div css={loadingWrapper}>
      <LoadingSpinner />
    </div>
  ) : error || data?.length === 0 ? (
    <> </>
  ) : isTeacher ? (
    isHomeVersion ? (
      <ChallengeTeacherHomePage
        expirationDate={expirationDate}
        subjects={subjects}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        activeData={activeData}
      />
    ) : (
      <ChallengesTeacher
        expirationDate={expirationDate}
        subjects={subjects}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        activeData={activeData}
      />
    )
  ) : (
    <div css={challengeWrapper(isHomeVersion)}>
      <ChallengeLandingHeader expirationDate={expirationDate} isHomeVersion />
      <ChallengesFolder
        subjects={subjects}
        isHomeVersion={isHomeVersion}
        isTeacher={isTeacher}
        activeData={activeData}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
    </div>
  );
};

ChallengeWrapperView.propTypes = propTypes;

export default ChallengeWrapperView;
